import { render } from "./PortalModulePlaceholder.vue?vue&type=template&id=63b0bc54"
import script from "./PortalModulePlaceholder.vue?vue&type=script&lang=js"
export * from "./PortalModulePlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__